export class TimingConstants {
	public static readonly WIN_LINE_STAGGER_DELAY: number = 70;
	public static readonly WIN_LINE_DELAY_BEFORE_NEXT_LINE: number = 300;
	public static readonly SYMBOL_REMOVE_STAGGER_DELAY: number = 50;
	public static readonly SEND_COIN_STAGGER_DELAY: number = 285;
	public static readonly START_SEND_COINS_DELAY: number = 1800;
	public static readonly ADD_COIN_COMPLETE_DELAY: number = 300;
	public static readonly SEND_COINS_COMPLETE_DELAY: number = 300;
}


// WEBPACK FOOTER //
// ./src/timing/TimingConstants.ts